import fCore from 'foundation-sites/dist/js/plugins/foundation.core.js';
// import fInterchange 			 	from 'foundation-sites/dist/js/plugins/foundation.interchange.js';
// import fReveal 							from 'foundation-sites/dist/js/plugins/foundation.reveal.js';
// import fMediaQuery 					from 'foundation-sites/dist/js/plugins/foundation.util.mediaQuery.js';
// import fTimerAndImageLoader from 'foundation-sites/dist/js/plugins/foundation.util.timerAndImageLoader.js';
// import fBox 								from 'foundation-sites/dist/js/plugins/foundation.util.box.js';
// import fTrigger 					  from 'foundation-sites/dist/js/plugins/foundation.util.triggers.js';
// import fAccordionResponsive	from 'foundation-sites/dist/js/plugins/foundation.responsiveAccordionTabs.js';
// import fMotion 					    from 'foundation-sites/dist/js/plugins/foundation.util.motion.js';
// import fAccordion					  from 'foundation-sites/dist/js/plugins/foundation.accordion.js';
import fTabs					  from 'foundation-sites/dist/js/plugins/foundation.tabs.js';
import fKeyboard					  from 'foundation-sites/dist/js/plugins/foundation.util.keyboard.js';
import  imgLoader					  from 'foundation-sites/dist/js/plugins/foundation.util.imageLoader.js';
// import fEqualizer 					from 'foundation-sites/dist/js/plugins/foundation.equalizer.js';

class FoundationInit {
  constructor() {
    this._init();
  }

  _init() {
    document.addEventListener('DOMContentLoaded', event => {
      const $ = jQuery;
      $(document).foundation();

      $('#champ_secteur').change(function() {
        $('#champ_secteur_hidden').val(
          $(this)
            .children('option:selected')
            .html()
        );
      });
    });
  }
}

export const foundationInit = new FoundationInit();
